import { MSGraphService, BasicProfileData, ProfileService } from '@careerhub/api';
import { all, call, fork, getContext, put, takeLatest } from 'redux-saga/effects';
import { User } from '@microsoft/microsoft-graph-types';

import {
  fetchMyProfileDetailsFailed,
  fetchMyProfileDetailsSuccess,
  fetchMyProfilePictureFailed,
  fetchMyProfilePictureSuccess,
  loadHrProfileSuccess,
  loadHrProfileFailed,
  UserProfileActionType,
} from './actions';
import { genericErrorMessage } from '../../Constants';

function* fetchMyProfileDetails() {
  const graphService: MSGraphService = yield getContext('graphService');
  try {
    const getMyProfileDetails = async () => {
      return await graphService.getMyDetails();
    };
    const profileDetails: User = yield call(getMyProfileDetails);
    yield put(fetchMyProfileDetailsSuccess(profileDetails));
  } catch (ex) {
    yield put(fetchMyProfileDetailsFailed(ex?.data?.errorMessage ?? 'Something went wrong. Please try again later.'));
  }
}

function* fetchMyProfilePicture() {
  const graphService: MSGraphService = yield getContext('graphService');
  try {
    const getMyProfilePicture = async () => {
      return await graphService.getMyPhoto();
    };
    const profilePicture: string = yield call(getMyProfilePicture);
    yield put(fetchMyProfilePictureSuccess(profilePicture));
  } catch (ex) {
    yield put(fetchMyProfilePictureFailed(ex?.data?.errorMessage ?? 'Something went wrong. Please try again later.'));
  }
}

function* handleFetchHrProfile() {
  const profileService: ProfileService = yield getContext('hrCoreService');
  try {
    const getHrProfile = async () => {
      const response = await profileService.getMyHrProfile();
      return response;
    };
    const hrProfile: Awaited<ReturnType<typeof getHrProfile>> = yield call(getHrProfile);
    yield put(loadHrProfileSuccess(hrProfile as BasicProfileData));
  } catch (ex) {
    yield put(loadHrProfileFailed(ex?.data?.errorMessage ?? genericErrorMessage));
  }
}

export function* myProfileDetailsSagas(): IterableIterator<{}> {
  yield takeLatest(UserProfileActionType.FETCH_MY_PROFILE_DETAILS, fetchMyProfileDetails);
}

export function* myProfilePictureSagas(): IterableIterator<{}> {
  yield takeLatest(UserProfileActionType.FETCH_MY_PROFILE_PICTURE, fetchMyProfilePicture);
}
export function* myHrProfileSagas(): IterableIterator<{}> {
  yield takeLatest(UserProfileActionType.LOAD_MY_HR_PROFILE, handleFetchHrProfile);
}

export function* userProfileSagas() {
  yield all([fork(myProfileDetailsSagas), fork(myProfilePictureSagas), fork(myHrProfileSagas)]);
}
